import { Controller } from "@hotwired/stimulus"

// Affiche en direct la valeur hex à côté d'un <input type="color">.
export default class extends Controller {
  static targets = ["input", "value"]

  update() {
    if (this.hasValueTarget) this.valueTarget.textContent = this.inputTarget.value
  }
}
